var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),(_vm.simulationmode)?_c('section',{staticClass:"container"},[_c('app-simulation'),_c('app-form')],1):_c('section',{staticClass:"container"},[_c('app-grid'),_c('app-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }